export const UNIVERSITY_WIDGET_INFO_REQUESTED = 'UNIVERSITY_WIDGET_INFO_REQUESTED'
export const UNIVERSITY_WIDGET_INFO_SUCCESS = 'UNIVERSITY_WIDGET_INFO_SUCCESS'
export const UNIVERSITY_WIDGET_INFO_FAILED = 'UNIVERSITY_WIDGET_INFO_FAILED'

export const SET_WIDGET_STYLES = 'SET_WIDGET_STYLES'
export const SET_WIDGET_STYLES_SUCCESS = 'SET_WIDGET_STYLES_SUCCESS'
export const SET_WIDGET_STYLES_FAILED = 'SET_WIDGET_STYLES_FAILED'
